<template>
	<div class="all-wrap">
		<!-- 留言按钮 -->
		<Comment class="commentWrap" />
		<!-- 置顶组件 -->
		<gotop></gotop>

		<!-- 顶部 banner 区(站内框架,高度紧凑) -->
		<div class="videolist-banner">
			<Headernew />
			<div class="bannertop-title">
				<div>报价详情</div>
				<div>——后天科技·项目报价</div>
			</div>
		</div>

		<!-- 主体 -->
		<div class="app-container">
			<div class="breadcrumb">
				<span class="clickable" @click="goList">全部报价</span>
				<span class="sep">/</span>
				<span class="current">详情</span>
			</div>

			<!-- 版块标签：点击滚动跳转 -->
			<div class="section-tabs" v-if="detail">
				<button class="section-tab" @click="scrollToSection('sec-info')">基本信息</button>
				<button class="section-tab" v-if="detail.related_id" @click="scrollToSection('sec-work')">关联作品</button>
				<button class="section-tab" v-if="detail.link_url || detail.html_url" @click="scrollToSection('sec-links')">链接</button>
				<button class="section-tab" v-if="detail.content" @click="scrollToSection('sec-content')">内容</button>
				<button class="section-tab" v-if="relatedScheme" @click="scrollToSection('sec-scheme')">关联方案</button>
			</div>

			<div v-if="detail" class="detail-card" id="sec-info">
				<div class="detail-title"><i class="iconfont icon-add"></i> {{ detail.main }}</div>

				<!-- 通用字段：有值才显示 -->
				<div class="field" v-if="detail.keys_name"><span class="label">分类</span><span class="value">{{ detail.keys_name }}</span></div>
				<div class="field" v-if="detail.tags"><span class="label">标签</span><span class="value">{{ detail.tags }}</span></div>
				<div class="field" v-if="detail.created_at"><span class="label">创建时间</span><span class="value">{{ detail.created_at }}</span></div>
			</div>
			<div v-else class="empty-state"><i class="iconfont icon-dengdai"></i><p>未找到该报价</p></div>

			<!-- 关联作品：through detail.related_id -->
			<div class="section-block" v-if="detail && detail.related_id" id="sec-work">
				<div class="section-title"><i class="iconfont icon-shipinbofangyingpian"></i> 关联作品</div>
				<button class="btn-link" @click="goWork(detail.related_id)"><i class="iconfont icon-shengyin"></i> 查看关联作品</button>
			</div>

			<!-- 链接版块 -->
			<div class="section-block" v-if="detail && (detail.link_url || detail.html_url)" id="sec-links">
				<div class="section-title">链接</div>
				<div v-if="detail.link_url" class="link-line"><a :href="detail.link_url" target="_blank" rel="noopener noreferrer"><span class="link-label">外链：</span>{{ detail.link_url }}</a></div>
				<div v-if="detail.html_url" class="link-line"><a :href="detail.html_url" target="_blank" rel="noopener noreferrer"><span class="link-label">页面：</span>{{ detail.html_url }}</a></div>
			</div>

			<!-- 内容版块 -->
			<div class="section-block" v-if="detail && detail.content" id="sec-content">
				<div class="section-title">内容</div>
				<div class="content-block" v-html="detail.content"></div>
			</div>

			<!-- 关联方案版块 -->
			<div class="section-block" v-if="relatedScheme" id="sec-scheme">
				<div class="section-title">关联方案</div>
				<button class="btn-link" @click="goScheme(relatedScheme.id)"><i class="iconfont icon-shipinbofangyingpian"></i> 查看关联方案</button>
			</div>
		</div>

		<Footernew />
	</div>
</template>

<script>
import Headernew from '@/components/Headernew.vue'
import Footernew from '@/components/Footernew.vue'
import Comment from '@/components/comment.vue'
import gotop from '@/components/gotop.vue'

export default {
	name: 'budgetDetail',
	components: { Headernew, Footernew, Comment, gotop },
	data() {
		return { detail: null }
	},
	created() {
		this.load()
	},
	computed: {
		// 关联方案：详情返回的 html 数组里 type 为 html 的记录
		relatedScheme() {
			const h = this.detail && this.detail.html
			if (Array.isArray(h)) {
				return h.find(r => r.type === 'html') || null
			}
			return null
		},
	},
	methods: {
		load() {
			this.$axios.get(this.$api + '/getHtmlPageById/' + this.$route.query.id)
				.then(res => { this.detail = res.data.result || null })
				.catch(err => { console.log(err) })
		},
		goScheme(id) { this.$router.push({ path: '/schemeDetail', query: { id } }) },
		goWork(id) { this.$router.push({ path: '/workDetail', query: { id } }) },
		goList() { this.$router.push('/projectProposal') },
		scrollToSection(id) {
			const el = document.getElementById(id)
			if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
		},
	},
}
</script>

<style scoped>
.videolist-banner { width: 100%; height: 300px; background-image: url(https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/imgs/mediabanner.jpg); background-size: 100% 100%; position: relative; }
.bannertop-title { width: 100%; position: absolute; left: 0; top: 45%; }
.bannertop-title div:nth-of-type(1) { width: 80%; margin: 0 auto; font-size: 38px; color: #fff; font-weight: bold; }
.bannertop-title div:nth-of-type(2) { width: 48%; margin: 14px auto 0; font-size: 18px; color: #fff; text-align: right; letter-spacing: 2px; }

.app-container { max-width: 900px; margin: 0 auto; padding: 2rem 1.5rem 4rem; text-align: left; }
.breadcrumb { display: flex; align-items: center; gap: .5rem; font-size: .9rem; color: #94a3b8; margin-bottom: 1.5rem; padding-bottom: .75rem; border-bottom: 1px solid #e9edf4; }
.breadcrumb .sep { color: #cbd5e1; }
.breadcrumb .clickable { cursor: pointer; color: #2563eb; font-weight: 500; }
.breadcrumb .clickable:hover { color: #1d4ed8; text-decoration: underline; }
.breadcrumb .current { color: #1e293b; font-weight: 500; }

.detail-card { box-sizing: border-box; max-width: 700px; margin: 0 auto; padding: 1rem 1.5rem; background: #fff; border-radius: 14px; border: 1px solid #eef2f6; box-shadow: 0 4px 12px rgba(0,0,0,.04); }
.detail-card .field { display: flex; padding: .6rem 0; border-bottom: 1px solid #f1f5f9; }
.detail-card .field:last-child { border-bottom: none; }
.detail-card .field .label { width: 90px; font-weight: 500; color: #64748b; flex-shrink: 0; font-size: .9rem; }
.detail-card .field .value { flex: 1; color: #0a2540; font-size: .95rem; word-break: break-word; }
.detail-title { font-size: 1.3rem; font-weight: 600; color: #0a2540; margin-bottom: 1rem; display: flex; align-items: center; gap: .5rem; }
.detail-title i { color: #2563eb; }
.value a { color: #2563eb; text-decoration: underline; word-break: break-all; }

/* 版块标签条 */
.section-tabs { max-width: 700px; margin: .5rem auto 1rem; display: flex; flex-wrap: wrap; gap: .5rem; }
.section-tab { background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; padding: .35rem .9rem; border-radius: 20px; font-size: .85rem; cursor: pointer; transition: all .15s; }
.section-tab:hover { background: #dbeafe; color: #2563eb; border-color: #2563eb; }
.detail-card, .section-block, .rel-card { scroll-margin-top: 90px; }

/* 分版块 */
.section-block { box-sizing: border-box; max-width: 700px; margin: 1.25rem auto 0; padding: 1rem 1.5rem; background: #fff; border-radius: 14px; border: 1px solid #eef2f6; box-shadow: 0 2px 8px rgba(0,0,0,.03); }
.section-title { font-size: .95rem; font-weight: 600; color: #0a2540; margin-bottom: .75rem; display: flex; align-items: center; gap: .4rem; }
.section-title i { color: #2563eb; }
.link-line { font-size: .9rem; margin-bottom: .5rem; }
.link-line a { color: #2563eb; text-decoration: underline; word-break: break-all; }
.link-label { color: #64748b; font-weight: 500; }

/* 富文本内容块 */
.content-block { line-height: 1.7; word-break: break-word; }

/* 关联按钮 */
.btn-link { background: #2563eb; color: #fff; border: none; padding: .5rem 1.4rem; border-radius: 30px; font-weight: 500; font-size: .9rem; cursor: pointer; display: inline-flex; align-items: center; gap: .4rem; transition: background .2s; }
.btn-link:hover { background: #1d4ed8; }

.empty-state { text-align: center; padding: 3rem 1rem; color: #94a3b8; }
.empty-state i { font-size: 2.5rem; opacity: .3; margin-bottom: .5rem; }

@media (max-width: 768px) {
	.videolist-banner { height: 220px; }
	.bannertop-title { top: 48%; }
	.bannertop-title div:nth-of-type(1) { font-size: 24px; }
	.bannertop-title div:nth-of-type(2) { font-size: 14px; width: 80%; }
	.app-container { padding: 1rem .75rem; }
	.detail-card { padding: 1rem; }
	.detail-card .field { flex-direction: column; gap: .2rem; }
	.detail-card .field .label { width: auto; }
}
</style>

<style>
@import '../../assets/css/alibaba.css';
</style>